import * as apiCalls from './rootApi';

const actions = {
    async startQuiz(params, {slug}) {
        try {
            return await apiCalls.startQuiz(slug);
        }
        catch (e) {
            console.error(e);
        }
    },

    async getQuestions() {
        try {
            return await apiCalls.getQuestions();
        }
        catch (e) {
            console.error(e);
        }
    },

    async updateQuiz(params, { answers }) {
        try {
            console.log(answers);
            return await apiCalls.updateQuiz(answers);
        }
        catch (e) {
            console.error(e);
        }
    },

    async getIncorrectAllowed() {
        try {
            return await apiCalls.getIncorrectAllowed();
        }
        catch (e) {
            console.error(e);
        }
    },

    async sendStackTrace(params, stackString) {
        console.error(stackString)
    },

}

export default actions